import React, { forwardRef } from 'react';
import Grid from '@mui/material/Grid';

const correctSize = (acc, sizeProp, sizePropValue) => {
  if (sizePropValue != null) {
    if (typeof sizePropValue === 'boolean' && sizePropValue === true) {
      acc[sizeProp] = 'grow';
    } else {
      acc[sizeProp] = sizePropValue;
    }
  }
  return acc;
};

const Grid2 = forwardRef(
  (
    {
      xs,
      sm,
      md,
      xl,
      lg,
      xsOffset,
      smOffset,
      mdOffset,
      lgOffset,
      xlOffset,
      children,
      ...props
    },
    ref,
  ) => {
    let sizeProps = {};
    sizeProps = correctSize(sizeProps, 'xs', xs);
    sizeProps = correctSize(sizeProps, 'sm', sm);
    sizeProps = correctSize(sizeProps, 'md', md);
    sizeProps = correctSize(sizeProps, 'lg', lg);
    sizeProps = correctSize(sizeProps, 'xl', xl);

    let offsetProps = {};
    offsetProps = correctSize(offsetProps, 'xs', xsOffset);
    offsetProps = correctSize(offsetProps, 'sm', smOffset);
    offsetProps = correctSize(offsetProps, 'md', mdOffset);
    offsetProps = correctSize(offsetProps, 'lg', lgOffset);
    offsetProps = correctSize(offsetProps, 'xl', xlOffset);

    return (
      <Grid size={sizeProps} offset={offsetProps} ref={ref} {...props}>
        {children}
      </Grid>
    );
  },
);

export default Grid2;
